import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import Input from "./common/input";
import AuthLayout from "./common/layout";
import { callAuthAPi } from "../utils/mainapp-api";
export default function OtpVerification() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  const handleClick = async () => {
    if (!otp) {
      await window.swal.fire({
        icon: "error",
        title: "Otp is required",
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
      return;
    }
    setLoading(true);
    const dataToPost = {
      otp: otp,
      email: localStorage.getItem("email"),
    };
    const response = await callAuthAPi(
      "post",
      "signup_email_verification",
      dataToPost,
      false
    );

    if (!response) {
      setLoading(false);
      return;
    }

    if (response.success) {
      localStorage.setItem("jwt_ahrvo", response.token);
      localStorage.setItem(
        "expiry",
        new Date(new Date().getTime() + 24 * 60 * 60 * 1000).valueOf()
      );
      navigate("/welcome", {});
    } else {
      await window.swal.fire({
        icon: "error",
        title: "Invalid Email Address",
        html: "OTP is not valid, please check the otp and try again",
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }
    setLoading(false);
  };
  return (
    <AuthLayout
      headTitle="OTP Verification - Ahrvo | Ahrvo"
      title={"OTP Verification"}
      subtitle={"Please enter the OTP code below"}
      form={
        <form>
          <Input
            placeholder={"Please enter the otp sent on your email"}
            label={"OTP"}
            value={otp}
            setValue={setOtp}
          />

          <div className="form-group">
            <button
              onClick={handleClick}
              type="button"
              style={{ width: "100%" }}
              className="btn btn-lg btn-primary btn-block"
            >
              {loading ? <Spinner color="white"></Spinner> : "Verify Otp"}
            </button>
          </div>
        </form>
      }
    />
  );
}
